import { Link } from 'react-router-dom';
import { Avatar, AvatarFallback } from '../ui/avatar';

export interface LatestTestRow {
  id: string;
  employeeName: string;
  department: string;
  averageRT: number;
  totalLapses: number;
}

interface LatestTestTableProps {
  rows: LatestTestRow[];
}

const getInitials = (name: string) =>
  name
    .split(' ')
    .map((part) => part[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

export function LatestTestTable({ rows }: LatestTestTableProps) {
  return (
    <div className="bg-navy-800 rounded-2xl p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-bold text-white">Recent tests</h2>
      </div>

      {rows.length === 0 ? (
        <div className="py-12 text-center text-sm text-navy-300">No completed tests available yet.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-navy-700">
                <th className="text-left py-3 px-2 font-medium text-sm text-navy-300">Name</th>
                <th className="text-left py-3 px-2 font-medium text-sm text-navy-300">Department</th>
                <th className="text-left py-3 px-2 font-medium text-sm text-navy-300">Avg RT (ms)</th>
                <th className="text-left py-3 px-2 font-medium text-sm text-navy-300">Lapses</th>
                <th className="text-left py-3 px-2 font-medium text-sm text-navy-300">Details</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id} className="border-b border-navy-800 hover:bg-navy-900">
                  <td className="py-4 px-2">
                    <div className="flex items-center gap-3">
                      <Avatar className="h-10 w-10">
                        <AvatarFallback className="bg-navy-700 text-gold-400">
                          {getInitials(row.employeeName)}
                        </AvatarFallback>
                      </Avatar>
                      <span className="font-medium text-white">{row.employeeName}</span>
                    </div>
                  </td>
                  <td className="py-4 px-2 text-navy-100">{row.department}</td>
                  <td className="py-4 px-2 text-navy-100">{Math.round(row.averageRT)}</td>
                  <td className="py-4 px-2 text-navy-100">{row.totalLapses}</td>
                  <td className="py-4 px-2">
                    <Link to={`/admin/results/${row.id}`} className="text-sm font-medium text-gold-400 hover:text-gold-300 underline">
                      View results
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
